{% block sw_category_seo_form %}
    <sw-container rows="auto auto">
        <sw-card-section divider="bottom">
            <div class="sw-category-seo-form">
                {% parent %}
            </div>
        </sw-card-section>
        <sw-card-section>
            <div>{{ $tc('hueb-seo.general.labelSerp') }}</div><br>
            <div class="hueb-seo__preview">
                <span class="hueb-seo__metaTitle">{{ category.metaTitle }}</span><br>
                <span class="hueb-seo__seoUrl">{{ seoUrl }}</span><br>
                <span class="hueb-seo__metaDescription">{{ category.metaDescription }}</span><br>
            </div>
        </sw-card-section>
    </sw-container>
{% endblock %}

{% block sw_category_seo_form_meta_title %}
    <div class="hueb-seo__category_label sw-field">
        <label class="sw-field__label" for="sw-field--category-metaTitle">
            {{ $tc('sw-product.seoForm.labelMetaTitle') }}&nbsp;
            <span class="hueb-seo__wordCount" v-bind:class="{ active: metaTitleColor }">{{ metaTitleCount }}</span>
        </label>
    </div>

    <mt-text-field
        :placeholder="$tc('sw-category.base.seo.placeholderMetaTitle')"
        v-model="category.metaTitle"></mt-text-field>
{% endblock %}

{% block sw_category_seo_form_meta_description %}
    <div class="hueb-seo__category_label sw-field">
        <label class="sw-field__label" for="sw-field--category-metaDescription">
            {{ $tc('sw-product.seoForm.labelMetaDescription') }}&nbsp;
            <span class="hueb-seo__wordCount" v-bind:class="{ active: metaDescriptionColor }">{{ metaDescriptionCount }}</span>
        </label>
    </div>
    <mt-textarea
        :placeholder="$tc('sw-category.base.seo.placeholderMetaDescription')"
        v-model="category.metaDescription">
    </mt-textarea>
{% endblock %}
